import consumer from './consumer';
import { log } from '../utils/logger';

function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

consumer.subscriptions.create('DownloadFileChannel', {
  connected() {
    log('connected to DownloadFileChannel');
  },

  disconnected() {
    log('disconnected from DownloadFileChannel');
  },

  received(data) {
    log('message received from DownloadFileChannel', data);

    let url = data.url;

    if (!url) {
      return;
    }

    if (isFirefox()) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  },
});
